import { render, staticRenderFns } from "./EcMineModule.vue?vue&type=template&id=708ce0c1&scoped=true"
import script from "./EcMineModule.vue?vue&type=script&lang=js"
export * from "./EcMineModule.vue?vue&type=script&lang=js"
import style0 from "./EcMineModule.vue?vue&type=style&index=0&id=708ce0c1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708ce0c1",
  null
  
)

export default component.exports